var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.relatedRealisationUuid)?_c('span',[_vm._v(" "+_vm._s(_vm.relatedRealisationCaseRef)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }